import { emitter, Events } from "./mitt";

const rabby = {};
rabby.connectName = "";
rabby.provider = null;
async function connectToWallet(provider) {
  try {
    const accounts = await provider.request({
      method: "eth_requestAccounts",
    });
    console.log("Connected to Rabby. Account:", accounts[0]);
    emitter.emit(Events.Update_Account, accounts[0]);
  } catch (error) {
    console.error("Failed to connect:", error);
  }
}

rabby.sendTransaction = async function (params) {
  console.log("sendTransaction to Rabby. Account:", params);
  try {
    const hash = await rabby.provider.request({
      method: "eth_sendTransaction",
      params: [params],
    });
    console.log("sendTransaction to Rabby. Account:", hash);
    return { hash };
    // emitter.emit(Events.Update_Account, accounts[0]);
  } catch (error) {
    console.error("Failed to sendTransaction:", error);
  }
};

function handleEIP6963Announce(event) {
  const { info, provider } = event.detail;
  rabby.provider = provider;
  console.log(
    `Detected wallet: ${info.name}`,
    "connect name:",
    rabby.connectName,
    "provider:",
    rabby.provider,
    "disconnected:",
    rabby.provider.isConnected()
  );
  if (info.name == rabby.connectName) {
    connectToWallet(provider);
  } else {
    // emitter.emit(
    //   Events.EventMin,
    //   `Please install ${rabby.connectName} to log in or select an alternative wallet.`
    // );
    // console.error(`No ${info.name} detected! Pls check!`);
  }
  // switch (connectName) {
  //   case "MetaMask":
  //     connectToWallet(provider);
  //     break;
  //   case "Rabby Wallet":
  //     connectToWallet(provider);
  //     break;
  // }
  // If it's Rabby wallet, connect
  // if (info.rdns === "io.rabby") {
  //   connectToWallet(provider);
  // }
}
rabby.disconnect = async function disconnect() {
  if (rabby.provider) {
    // metamask断开链接
    await rabby.provider.request({
      method: "wallet_revokePermissions",
      params: [
        {
          eth_accounts: {},
        },
      ],
    });
    // console.log("rabby.provider:", rabby.provider, result);
  }
  if (window.ethereum) {
    // rabby wallet 断开连接
    await window.ethereum.request({
      method: "wallet_revokePermissions",
      params: [
        {
          eth_accounts: {},
        },
      ],
    });
  }

  window.removeEventListener("eip6963:announceProvider", handleEIP6963Announce);
};
rabby.reset = async function reset() {
  rabby.connectName = "";
  window.removeEventListener("eip6963:announceProvider", handleEIP6963Announce);
};
rabby.connectWithEIP6963 = async function connectWithEIP6963(
  connectName = "Rabby Wallet"
) {
  if (typeof window.ethereum === "undefined") {
    console.error("No EIP-1193 wallet detected");
    return;
  }
  rabby.connectName = connectName;

  // Define event listener

  // Add event listener
  window.addEventListener("eip6963:announceProvider", handleEIP6963Announce);

  // Request wallet announcement
  window.dispatchEvent(new Event("eip6963:requestProvider"));

  // Function to connect to wallet
};
export default rabby;
